import { BaseTable, Loading, PaginationData, Card, DateInput, Select, TableHeader, TableNumber, PermissionLink, ActionButton, Button, Modal, TableSorting, TableHeaderSort, Input } from "components";
import { PaginationState, SuccessFetch } from "types";
import { APPROVAL_OPTIONS, default_pagination_value, useLocation, useApi } from "utils";
// import { FilterSection } from "./components";
// import { Link } from "react-router-dom";
import { convertNumber, APPROVAL, useToggle } from "utils";
import { Fragment, useContext, useEffect, useState } from "react";
import moment from "moment";
import { IoSendSharp } from "react-icons/io5"
import { IoIosWarning } from "react-icons/io"
import toast from "react-hot-toast"
import { DataContext } from "../utils/contexts";
import { FilterColumn } from "../components";
import { debounce } from "lodash";
import { PERMISION } from "security";

export interface FillType extends PaginationState {
  start_date?: string;
  end_date?: string;
  location_id?: string;
  approve_status?: string;
  group_id?: string;
}
// 1. TIPE UTAMA UNTUK FETCH RESPONSE
export interface ApiResponse<T> {
  status: string;
  responseStatus: number;
  message: string;
  payload: T;
}

// 2. TIPE UNTUK PAGING + LIST
export interface DataTypePaging<T> {
  listfile: T[];
  pagination_data: {
    total: number;
    page: number;
    size: number;
    pages: number;
  };
}

// 3. TIPE UNTUK SETIAP ITEM
export interface BuildFile {
  build_id: number;
  trx_code: string;
  transaction_date: string;
  product_id: number;
  product_barcode: string;
  product_name: string;
  mr_product_group_id: number;
  mr_product_group_name: string;
  qty_build_unit: number;
  unit_convention_id: number;
  component_at_cost: number;
  avg_price: number;
  mr_unit_name: string;
  location_id: number;
  location_name: string;
  approve_status: number;
  approve_date: string | null;
  approve_by: number | null;
  employee_id: number | null;
  employee_name: string | null;
  created_at: string;
  created_by: number;
  updated_at: string | null;
  updated_by: number | null;
}

export function RegisterItemsBuild() {

  const [pagination, setPagination] = useState<FillType>({
    ...default_pagination_value,
    start_date: moment().startOf("month").format("YYYY-MM-DD"),
    end_date: moment().endOf("month").format("YYYY-MM-DD"),
    location_id: '0',
    approve_status: '0',
    group_id: '0',
  });

  const onDebounce = debounce((e: any) =>
      setPagination((prev) => {
        return {
          ...prev,
          keyword: e.target.value,
          page: 1,
          group_id: "",
          sort: "",
        };
      })
    );

  const { data: location, isLoading: loadingLocation } = useLocation();
  const { data, isLoading, refetch } = useBuildList(pagination);

  const { setFill, setActiveColumn } = useContext(DataContext);

  const header: TableSorting[] = [
    { title: "BUILD ID#", value: "trx_code", isActive: true },
    { title: "DATE", value: "transaction_date", isActive: true },
    { title: "BARCODE", value: "barcode", isActive: true },
    { title: "DESCRIPTION", value: "description", isActive: true },
    { title: "GROUP", value: "group_name", isActive: true },
    { title: "LOCATION", value: "location_name", isActive: true },
    { title: "TRADER", value: "employee_name", isActive: true },
    { title: "APPROVED", value: "approve_status", isActive: true },
    { title: "QTY BUILD", value: "qty", isActive: true },
    { title: "UNIT", value: "unit", isActive: true },
    { title: "CAC", value: "cac", isActive: true },
    { title: "AVERAGE", value: "avg_price", isActive: true },
  ]

  const [tableActive, setTableActive] = useState<TableSorting[]>(header);

  useEffect(() => {
    setActiveColumn && setActiveColumn(tableActive);
    setFill({ 
        dateFrom: pagination.start_date, 
        dateTo: pagination.end_date, 
        location_id: pagination.location_id,
        approval_status: pagination.approve_status,
        group_id: pagination.group_id
    });
  }, [
    setActiveColumn,
    setFill,
    tableActive,
    pagination.start_date,
    pagination.end_date,
    pagination.location_id,
    pagination.approve_status,
    pagination.group_id
  ]);



  return (
    <section className="my-2 flex flex-col gap-3">
      <Card>
        <Card.Body>
          <section className="lg:flex justify-between">
            <div className="lg:flex lg:items-end gap-3 mt-2 w-full">
              <DateInput
              label="START DATE"
              wrapperClassName="lg:w-[180px]"
              onChange={(date) =>
                setPagination({
                  ...pagination,
                  start_date: moment(date).format("YYYY-MM-DD"),
                })
              }
              selected={
                pagination.start_date ? moment(pagination.start_date).toDate() : null
              }
            />

            <DateInput
              label="END DATE"
              wrapperClassName="lg:w-[180px]"
              onChange={(date) =>
                setPagination({
                  ...pagination,
                  end_date: moment(date).format("YYYY-MM-DD"),
                })
              }
              selected={
                pagination.end_date ? moment(pagination.end_date).toDate() : null
              }
            />

            <Select
              label="LOCATION"
              controlClass="lg:w-[180px]"
              width
              options={[{ label: "All", value: "0" }, ...location]}
              value={[{ label: "All", value: "0" }, ...location].find(
                (item) => item.value === pagination.location_id
              )}
              isLoading={loadingLocation}
              onChange={(e) => {
                if (e) {
                  setPagination({ ...pagination, location_id: e.value });
                }
              }}
            />

            <Select
              label="APPROVED"
              controlClass="lg:w-[180px]"
              width
              options={[{ label: "All", value: "0" }, ...APPROVAL_OPTIONS]}
              value={[{ label: "All", value: "0" }, ...APPROVAL_OPTIONS].find(
                (item) => item.value === pagination.approve_status
              )}
              onChange={(e) => {
                console.log(e);
                if (e) {
                  setPagination({ ...pagination, approve_status: e.value });
                }
              }}
            />

            <FilterColumn
              dataFilter={tableActive}
              setTableActive={setTableActive}
            />
            </div>

            <div>
              <Input
                                    label="SEARCH"
                                    className="lg:w-[300px] md:w-full"
                                    placeholder="Search data..."
                                    onChange={onDebounce}
                                  />
            </div>
          </section>
        </Card.Body>
      </Card>

      <div className="overflow-x-auto max-h-[calc(100vh-460px)]">
        <BaseTable className="border-collapse">
          <TableHeader>
            <tr>
              <th>NO</th>

              <TableHeaderSort
                title={tableActive}
              />

              <th>ACTION</th>
            </tr>
          </TableHeader>

          <tbody>
            {isLoading || data.listfile.length === 0 ? (
              <tr>
                <td colSpan={12}>
                  <Loading loading={isLoading} errorText="No data available" />
                </td>
              </tr>
            ) : (
              <>
                {data?.listfile.map((item, key) => (
                  <tr key={key}>
                    <td>
                      {TableNumber({
                        dataLength: pagination.limit,
                        pageCurrent: pagination.page,
                        index: key,
                        limit: pagination.limit,
                        totalData: pagination.total
                      })}
                    </td>

                    {/* Kolom filter */}
                    {tableActive
                      .filter((col) => col.isActive !== false)
                      .map((col, idx) => (
                        <Fragment key={idx}>
                          {renderCell(col.value!, item)}
                        </Fragment>
                      ))}

                    <td className="w-[120px] text-center">
                      <div className="flex gap-2">
                        {item.approve_status === APPROVAL.PENDING && (
                          <PermissionLink permission={PERMISION.INVENTORY.REGISTER.BUILD_ITEM.UPDATE} rel="noopener noreferrer" to={`/inventory/transaction/build-item/edit/${item.build_id}`} >
                            <IoSendSharp />
                          </PermissionLink>
                        )}
                        {item.approve_status === APPROVAL.PENDING && (
                          <Delete id={item.build_id} refetch={refetch} />
                        )}

                        {item.approve_status === APPROVAL.APPROVED && (
                          <PermissionLink permission={PERMISION.INVENTORY.REGISTER.BUILD_ITEM.UPDATE} rel="noopener noreferrer" to={`/inventory/transaction/build-item/edit/${item.build_id}`} >
                            <IoSendSharp />
                          </PermissionLink>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </BaseTable>
        <div className="p-2">
          <PaginationData data={data} pagination={pagination} setPagination={setPagination} />
        </div>
      </div>
    </section>
  );
}

type FilterState = {
  page?: number
  approve_status?: string
  limit?: number
  start_date?: string
  end_date?: string
  location_id?: string
  group_id?: string
  keyword?: string
}

function useBuildList({ page, approve_status, start_date, end_date, location_id, group_id, limit, keyword }: FilterState) {

  const defaultValue: DataTypePaging<BuildFile> = {
    listfile: [],
    pagination_data: {
      total: 0,
      page: 0,
      size: 0,
      pages: 0
    }
  };

  const api = useApi();
  const [data, setData] = useState<DataTypePaging<BuildFile>>(defaultValue);
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | undefined } = {}
  if (page) params.page = page;
  if (approve_status) params.approve_status = approve_status;
  if (start_date) params.date_from = start_date;
  if (end_date) params.date_end = end_date;
  if (location_id) params.location_id = location_id;
  if (group_id) params.group_id = group_id;
  if (limit) params.limit = limit;
  if (keyword) params.keyword = keyword;
  params.sort = "builddate:desc";

  const fetchUrl = () => {
    return api.get("/list_build_item/builditems?", { params })
  }

  const fetchData = () => {
    setLoading(true);

    fetchUrl().then((res: SuccessFetch<ApiResponse<DataTypePaging<BuildFile>>>) => {
      setData(res.data.payload); // payload berisi listfile dan pagination_data
    }).catch(() => {
      setData(defaultValue);
    }).finally(() => {
      setLoading(false);
    });
  }

  const refetch = () => fetchData();

  useEffect(() => {
    fetchData();

    return () => {
      setData(defaultValue);
      setLoading(true);
    }
    // eslint-disable-next-line
  }, [page, approve_status, start_date, end_date, location_id, group_id, limit, keyword]);

  return { data, isLoading, refetch }
}

function Delete({
  id,
  refetch
}: {
  id: number,
  refetch?: () => void
}) {
  const api = useApi()
  const { isActive, toggle } = useToggle(false)
  const [isLoading, setIsLoading] = useState(false)

  const onDelete = () => {
    setIsLoading(true)
    return new Promise<void>((resolve) => {
      toast.promise(
        api.delete(`/list_build_item/delete_build`, { params: { build_id: id } }),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => err.response.data.message
        }
      ).then(() => {
        setIsLoading(false)
        toggle()
        refetch && refetch()
      }).catch(() => { }).finally(resolve)
    })
  }


  return (
    <>
      <ActionButton.Delete permission={PERMISION.INVENTORY.REGISTER.BUILD_ITEM.DELETE} onClick={toggle} />


      {isActive && (
        <Modal isOpen title="DELETE ITEM ADJUSTMENT" size="xl" closeModal={toggle}>
          <h5 className="text-error ml-3">Are you sure want to delete this data?</h5>

          <IoIosWarning className="mx-auto mt-5 text-[200px] text-primary" />

          <Modal.Footer className="text-end">
            <Button
              type="submit"
              color="error"
              loading={isLoading ? "true" : undefined}
              onClick={onDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>

  )
}


function renderCell(value: string, item: BuildFile) {
  switch (value) {
    case "trx_code":
      return <td>{item?.trx_code}</td>
    case "transaction_date":
      return <td>{moment(item?.transaction_date).format("DD/MM/YYYY")}</td>
    case "barcode":
      return <td>{item?.product_barcode}</td>
    case "description":
      return <td>{item?.product_name}</td>
    case "group_name":
      return <td>{item?.mr_product_group_name}</td>
    case "location_name":
      return <td>{item?.location_name}</td>
    case "employee_name":
      return <td>{item?.employee_name}</td>
    case "approve_status":
      return <td>{Object.keys(APPROVAL).find(key => APPROVAL[key as keyof typeof APPROVAL] === item.approve_status) ?? '-'}</td>
    case "qty":
      return <td className="text-center">{item.qty_build_unit ? convertNumber(item?.qty_build_unit).intoCurrency : ""}</td>
    case "unit":
      return <td >{item?.mr_unit_name}</td>
    case "cac":
      return <td className="text-right">{item.component_at_cost ? convertNumber(item?.component_at_cost).intoNormalAmount : ""}</td>
    case "avg_price":
      return <td className="text-right">{item.avg_price ? convertNumber(item?.avg_price).intoCurrency : ""}</td>
    default:
      return <></>;
  }
}
